import { unwrap, unwrapVoid } from '../http.js';
export function createHabitsApi(client) {
    return {
        async range(query) {
            return unwrap(await client.GET('/v1/me/habits', { params: { query: query ?? {} } }));
        },
        async log(date, body) {
            return unwrap(await client.PUT('/v1/me/habits/{date}', { params: { path: { date } }, body }));
        },
        async delete(date) {
            unwrapVoid(await client.DELETE('/v1/me/habits/{date}', { params: { path: { date } } }));
        },
    };
}
//# sourceMappingURL=habits.js.map